<template>
  <div class="home">
    <!--<img alt="Vue logo" src="../assets/logo.png">-->
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <main>
<!-- ヘッダー -->
<header class="header-box">
  <div class="inner">
    <div class="header-button" @click="this.changeLocale()"><img src="../assets/image/translation.png" alt=""></div>
  </div>
</header>

<!-- メインビジュアル -->
<div class="mv common-box">
  <div class="inner">
    <!-- <a href="" class="translation-button"><img src="../assets/image/translation.png" alt=""></a> -->
    <p class="catch white-space marker"> {{ $t('home.sub_title1') }}<wbr>{{ $t('home.sub_title2') }}</p>
    <h1 class="heading-level1 white-space">{{ $t('home.title1') }}<wbr>{{ $t('home.title2') }}</h1>
    <figure><img src="../assets/image/mv01.png" alt=""></figure>
    <span v-if="this.$store.state.user_info.user_id">
      <a @click="get_restart()" class="basic-button">{{ $t('home.get_restart') }}</a>
    </span>
    <span v-else>
      <a @click="get_start()" class="basic-button">{{ $t('home.get_start') }}</a>
    </span>
  </div>
</div>

<!-- 特徴 -->
<section class="common-box -green">
  <div class="inner">
    <div class="round-box">
    <h2 class="heading-level2 white-space" data-en="FEATURES">{{ $t('section.features_title1') }}<wbr>{{ $t('section.features_title2') }}</h2>
      <ol class="column">
        <li>
          <img src="../assets/image/image01.png" alt="">
          <p class="catch">{{ $t('section.features1') }}</p>
          <p>{{ $t('section.features1_description') }}</p>
        </li>
        <li>
          <img src="../assets/image/image02.png">
          <p class="catch">{{ $t('section.features2') }}</p>
          <p>{{ $t('section.features2_description') }}</p>
        </li>
        <li>
          <img src="../assets/image/image03.png">
          <p class="catch">{{ $t('section.features3') }}</p>
          <p>{{ $t('section.features3_description') }}</p>
        </li>
        <!-- <li>
          <img src="../assets/image/image04.png">
          <p class="catch">{{ $t('section.features4') }}</p>
          <p>{{ $t('section.features4_description') }}</p>
        </li> -->
      </ol>
    </div>
  </div>
</section>
<!-- 使い方 -->

<section class="common-box">
  <div class="inner">
    <h2 class="heading-level2 white-space" data-en="HOW TO USE">{{ $t('section.how-to_title1') }}<wbr>{{ $t('section.how-to_title2') }}</h2>
    <ol class="column howto">
      <li>
        <figure>
          <img src="../assets/image/image05.png" alt="">
          <figcaption class="howto_description">{{ $t('section.howto1_description') }}</figcaption>
        </figure>
      </li>
      <li>
        <figure>
          <img src="../assets/image/image06.png" alt="">
          <figcaption class="howto_description">{{ $t('section.howto2_description') }}</figcaption>
        </figure>
      </li>
      <li>
        <figure>
          <img src="../assets/image/image07.png" alt="">
          <figcaption class="howto_description">{{ $t('section.howto3_description') }}</figcaption>
        </figure>
      </li>
    </ol>
  </div>
</section>

<!-- はじめてみる -->
<!-- 
<section class="common-box -green">
  <div class="inner">
    <div class="round-box">
    <h2 class="heading-level2 white-space" data-en="START"><span>{{ $t('section.start_title1') }}<wbr>{{ $t('section.start_title2') }}</span></h2>
      <div class="column">
        <figure>
          <img src="../assets/image/image_qr.png" alt="">
          <figcaption>{{ $t('section.qr_caption') }}</figcaption>
        </figure>
      </div>
      <span v-if="this.$store.state.user_info.user_id">
      <a @click="get_restart()" class="basic-button">{{ $t('home.get_restart') }}</a>
    </span>
    <span v-else>
      <a @click="get_start()" class="basic-button">{{ $t('home.get_start') }}</a>
    </span>
    </div>
  </div>
</section>
-->

  <div class="common-box">
    <HomeAdSense />
    <div class="inner">
      <ol class="menu">
        <li><router-link class="nav-link" to="/terms">{{ $t('menu_terms_policy') }}</router-link></li>
        <li><router-link class="nav-link" to="/faq">{{ $t('menu_faq') }}</router-link></li>
        <li><a class="nav-link" href="https://docs.google.com/forms/d/e/1FAIpQLScVHFQq541RNFLY4sPWp7SgNOIQFbVU8jcI2Comr39biBFhNw/viewform" target="_blank">{{ $t('menu_form') }}</a></li>
      </ol>
    </div>
  </div>
  
  <!-- フッター -->
  <FooterComponent />
  </main>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import myMixin from '@/mixins/globalValiables';
import FooterComponent from '@/components/FooterComponent.vue';
import HomeAdSense from '@/components/HomeAdSense.vue';

export default {
  mixins: [myMixin],
  name: 'HomeView',
  components: {
    FooterComponent,  // FooterComponent をここで登録
    HomeAdSense
  },
  data() {
    return {
      login_error: ""
    };
  },
  mounted:async function () {
    await this.check_already_registration()
  },
  methods: {
    check_already_registration: async function () {
      console.log("check_already_registration")
      if (this.$store.state.user_info){
        console.log(this.$store.state.user_info.user_id) 
      }
    },
    get_restart: async function () {
      this.$router.push({ name: "itemlist" });
    },
    get_start: async function () {
      let jsonbody = {};
      jsonbody.api_type = "pre_makeuser";

      await this.axios
        .post(this.$store.state.api_baseurl + "pre_makeuser", jsonbody, this.$store.state.post_headers)
        .then((res) => {
          this.$store.commit("set_pre_user_info", res.data.user_id);
          this.$router.push({ name: "makeuser" });
        })
        .catch((e) => {
          alert(e);
        });
    },
  },
}


</script>

<style src="./HomeView.css"></style>